import { CountryCode } from 'libphonenumber-js';
import { Country, CountryService } from './types';
import { ULRequest } from '@ul/request';

interface CountryResponse {
    id: number;
    languageId?: number;
    name: string;
    callingCode: string;
    iso2: CountryCode;
    latitude: string;
    longitude: string;
}

const mapCountry = (origin: string) => (country: CountryResponse): Country => ({
    id: +country.id,
    languageId: country.languageId,
    name: country.name,
    callingCode: `+${country.callingCode}`,
    countryCode: country.iso2,
    isSuggested: country.iso2 === origin,
});

const queryCountries = async (languageId: number, origin: string) => {
    const host = 'https://cdn6.agoda.net';
    return (
        (await ULRequest.getJson<CountryResponse[]>(`/js/static/v2/countries-${languageId}.json`, host)()).data ??
        (await ULRequest.getJson<CountryResponse[]>('/js/static/v2/countries-1.json', host)()).data ??
        []
    ).map(mapCountry(origin));
};

export class StaticCountryService implements CountryService {
    private readonly promise: Promise<Country[]>;

    constructor(languageId: number, origin: string) {
        // Initiate and store
        this.promise = queryCountries(languageId, origin);
    }

    public query = () => this.promise;
}
